import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  // 모든 링크는 동적으로만 처리됩니다
];

const MobileProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState(staticLinks);

  // 디버깅용 로그
  useEffect(() => {
    console.log('MobileProduct - 현재 links 상태:', links);
  }, [links]);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기 (PC 버전과 동일)
    const fetchBoardTables = async () => {
      try {
        console.log('=== MobileProduct fetchBoardTables 시작 ===');
        const response = await fetch('/request/getBoardTables?category=Product', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('받은 데이터:', data);

        // 서버에서 배열을 직접 반환하므로 그대로 사용
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          dynamicLinks = data.map(table => ({
            path: `/Product/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }

        console.log('생성된 동적 링크들:', dynamicLinks);
        
        // 정적 링크와 동적 링크 결합
        setLinks([...staticLinks, ...dynamicLinks]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  console.log('MobileProduct render - links:', links, 'length:', links.length);

  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="상품 관리"
      backPath="/"
    >
      <Outlet />
    </MobileSubNavigator>
  );
};

export default MobileProduct;